import { TransactionsDetailsItemFromServer } from './types'
import { getFinsystemNumberFormat } from '../../../../../libs/utils'

export const getTransactionItems = (
  transactions: TransactionsDetailsItemFromServer[],
) => {
  return transactions?.map((item) => ({
    ...item,
    amount: `${getFinsystemNumberFormat(item.amount, 8)} ${item.currency}`,
    amountUsd: `${getFinsystemNumberFormat(item.amountUsd, 8)}`,
    ourCommission: `${getFinsystemNumberFormat(item.ourCommission, 8)} ${
      item.ourCommissionCurrency
    }`,
    psCommission: `${getFinsystemNumberFormat(item.psCommission, 8)} ${
      item.psCommissionCurrency
    }`,
    clientAmount: `${getFinsystemNumberFormat(item.clientAmount, 8)} ${
      item.clientCurrency
    }`,
    exchangeRate: `${getFinsystemNumberFormat(item.exchangeRate, 8)}`,
  }))
}
